
import { computed, defineComponent, PropType, ref } from 'vue';
import { Skill } from '../ts/model/Skill';
import { settings } from '../ts/settings';

export default defineComponent({
  props: {
    skill: {
      type: Object as PropType<Skill>,
      required: true,
    },
  },
});
